import { useMemo } from 'react';
import columnDefinitionEnum, {
    ConcreteColumnDefinitionData,
} from '../queues/column-definition.enum';
import { useQueueStore } from '../queues/context/use-queue-store';

const COLUMNS_BY_ASSIGNMENT_STATUS = {
    undefined: [
        'PRIORITY',
        'RISK_LEVEL',
        'DISPATCH_AREA',
        'TIME_RECEIVED',
        'MINUTES_STANDING',
        'BEAT',
        'DISTANCE_FROM_EVENT',
    ],
    true: [
        'PRIORITY',
        'RISK_LEVEL',
        'DISPATCH_AREA',
        'TIME_RECEIVED',
        'MINUTES_WORKING',
        'BEAT',
        'DISTANCE_FROM_EVENT',
    ],
    false: [
        'PRIORITY',
        'RISK_LEVEL',
        'DISPATCH_AREA',
        'TIME_RECEIVED',
        'BEAT',
        'DISTANCE_FROM_EVENT',
    ],
};

export const useEventSortColumns = (): ConcreteColumnDefinitionData[] => {
    const queueStore = useQueueStore();
    const assignmentStatus = queueStore.workspacePanel.queue.assignmentStatus;

    return useMemo(
        () =>
            Object.values(columnDefinitionEnum)
                .filter((column) =>
                    COLUMNS_BY_ASSIGNMENT_STATUS[`${assignmentStatus}`].includes(column.name)
                )
                .sort((columnA, columnB) => columnA.displayName.localeCompare(columnB.displayName)),
        [assignmentStatus]
    );
};
